import moment from 'moment';

export const DASHBOARD_ALL_TIME_LABEL = 'All Time';

export const formatDashboardTimeframeLabel = (start, end) => {
  const startMoment = moment(start);
  const endMoment = moment(end);

  if (!startMoment.isValid() || !endMoment.isValid()) {
    return '';
  }

  if (startMoment.isSame(endMoment, 'day')) {
    return startMoment.format('MMM D, YYYY');
  }

  if (startMoment.isSame(endMoment, 'year')) {
    return `${startMoment.format('MMM D')} - ${endMoment.format(
      'MMM D, YYYY'
    )}`;
  }

  return `${startMoment.format('MMM D, YYYY')} - ${endMoment.format(
    'MMM D, YYYY'
  )}`;
};

export const getDashboardTimeframeDayCount = (start, end) => {
  const startMoment = moment(start);
  const endMoment = moment(end);

  if (!startMoment.isValid() || !endMoment.isValid()) {
    return 0;
  }

  return Math.abs(
    Math.floor(moment.duration(startMoment.diff(endMoment)).asDays())
  );
};

export const getDashboardPresetTimeframe = (count, format = 'day') => {
  if (count === 'all') {
    return {
      start: null,
      end: null,
      allTime: true,
      label: DASHBOARD_ALL_TIME_LABEL
    };
  }

  const end = moment();
  const start =
    count === 'current'
      ? moment().startOf(format)
      : moment().subtract(count, format);

  return {
    start: start.format(),
    end: end.format(),
    allTime: false,
    label: formatDashboardTimeframeLabel(start, end)
  };
};
